import '../../../../../vendor/bower_components/owl.carousel';
import YoutubeVideo from '../modules/YoutubeVideo';

class Home {

    constructor() {
        window.Nav.navOpacityChanger();

        $(document).ready(() => {
            return this.headerSection();
        });

        $('.owl-carousel-homepage img').first().on('load', () => {
            return $('.owl-carousel-homepage').trigger('refresh.owl.carousel');
        });

        this.headerSection();

        $(window).scroll(() => {
            return this.windowScrollEventHandler();
        });

        $(window).on('focus', () => {
            return $('.owl-next').trigger('click');
        });

        this.testimonialsSection();

        this.waypoints();

        this.matchHeights('.features .features-text');
        $(window).resize(() => {
            return this.matchHeights('.features .features-text');
        });

        new YoutubeVideo({
            elementID: 'video-block',
            playerVars: {
                controls: 0,
                disablekb: 0,
                modestbranding: 1,
                showinfo: 0,
                autohide: 1,
            },
        });
    }

    matchHeights(selector) {
        let min = 0;
        const $elements = $(selector);
        $elements.css({
            height: 'auto',
        });

        if ($(window).width() > 767) {
            $elements.each((i, el) => {
                if ($(el).outerHeight() > min) {
                    return min = $(el).outerHeight();
                }
            });
            $elements.css({
                height: min,
            });
        }

        return this.featureWaypoints();
    }

    featureWaypoints() {
        if (!$('body.browser-chrome-ios').length) {
            return $('section.features .feature').waypoint({
                handler(direction) {
                    return $(this.element).addClass('inview');
                },
                offset: '95%',
            });
        }
    }

    windowScrollEventHandler() {
        const $header = $('section.header');
        const offset = $(window).scrollTop() * 0.25;
        return $header.css({
            'background-position': `50% ${ offset }px`,
        });
    }

    headerSection() {
        // Run after script has loaded
        let owl;
        if (window.innerWidth > 992) {
            return owl = $('.owl-carousel-homepage').owlCarousel({
                loop: true,
                animateOut: 'fadeOut',
                margin: 55,
                dots: false,
                autoHeight: true,
                autoplay: true,
                autoplayTimeout: 6500,
                responsive: {
                    0: {
                        items: 1,
                    },
                    992: {
                        items: 1,
                    },
                },
            });
        }
        return owl = $('.owl-carousel-homepage').owlCarousel({
            loop: true,
            margin: 55,
            dots: false,
            autoHeight: true,
            autoplay: true,
            autoplayTimeout: 6500,
            responsive: {
                0: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
            },
        });

    }

    testimonialsSection() {
        // Run after script has loaded
        return $('.owl-carousel-testimonials').owlCarousel({
            loop: true,
            margin: 55,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            dots: true,
            slideBy: 'Page.js',
            autoplay: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                },
                992: {
                    items: 1,
                    nav: true,
                },
            },
        });
    }

    waypoints() {
        return $('section.trial').waypoint({
            handler(direction) {
                return $(this.element).addClass('inview');
            },
            offset: '75%',
        });
    }
}

export default Home;
